// extracted by mini-css-extract-plugin
export default {"collapseModal":"collapseModal_collapseModal__+NTJp","header":"collapseModal_header__rauZu","icon":"collapseModal_icon__Zst7r","content":"collapseModal_content__7-dKy"};